var render, staticRenderFns
import script from "./verticalSubTableColumn.vue?vue&type=script&lang=js&"
export * from "./verticalSubTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/verticalSub/verticalSubTableColumn.vue"
export default component.exports